module.exports = __webpack_public_path__ + "static/media/failIcon.bf1cc2c0.png";